import { maybeStaticVersionField, mergeQueryTypes } from '../util/network/QueryUtility';
import { ActivityQueries }                          from './ActivityQueries';
import { AssumptionQueries }                        from './AssumptionQueries';
import { CategoryQueries }                          from './CategoryQueries';
import { DataValueSetQueries }                      from './DataValueSetQueries';
import { IntakeQuestionQueries }                    from './IntakeQuestionQueries';
import { ObjectiveGroupQueries }                    from './ObjectiveGroupQueries';
import { ObjectiveQueries }                         from './ObjectiveQueries';
import { ResourceQueries }                          from './ResourceQueries';
import { MetaTagQueries }                           from './MetaTagQueries';
import { QuerySetKeys }                             from '../types';


const querySets = [
    ActivityQueries,
    AssumptionQueries,
    CategoryQueries,
    DataValueSetQueries,
    IntakeQuestionQueries,
    ObjectiveGroupQueries,
    ObjectiveQueries,
    ResourceQueries,
    MetaTagQueries,
];

type QuerySegmentType<D extends QuerySetKeys> =
    typeof ActivityQueries[D] &
    typeof AssumptionQueries[D] &
    typeof CategoryQueries[D] &
    typeof DataValueSetQueries[D] &
    typeof IntakeQuestionQueries[D] &
    typeof ObjectiveGroupQueries[D] &
    typeof ObjectiveQueries[D] &
    typeof ResourceQueries[D] &
    typeof MetaTagQueries[D];

const DecisionEngineQueries = {
    fragments: mergeQueryTypes( querySets, 'fragments' ) as QuerySegmentType<'fragments'>,
    queries:   mergeQueryTypes( querySets, 'queries' ) as QuerySegmentType<'queries'>,
    mutations: mergeQueryTypes( querySets, 'mutations' ) as QuerySegmentType<'mutations'>,
    functions: mergeQueryTypes( [
        ...querySets,
        {
            fragments: {},
            queries:   {},
            mutations: {},
            functions: {
                MAYBE_STATIC_VERSION_FIELD: maybeStaticVersionField
            }
        }
    ], 'functions' ) as QuerySegmentType<'functions'>,
};

export { DecisionEngineQueries }
